import { Field } from 'react-final-form';

import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Toggler from 'components/shared/FormAdapters/FormDefault/Toggler';
import Modal from 'components/shared/Modal';
import { Select } from 'components/shared/Select/adapters/FinalForm';
import Text from 'components/shared/Typography/Text';
import { AGENT_PERMISSION_WHITE_LABELING, useIsSubscriptionAllowed } from 'hooks/useIsSubscriptionAllowed';
import { isNotDefined } from 'utils/ramda';

import { ACCOUNT_TYPE_AGENT } from '../../../../../../constants';
import { BlockerForAgent } from '../../../../../../hooks/useSubscriptionBlockContent';
import { useWhiteLabeling } from './functions';
import s from './index.module.css';
import PartnerAgentForm from './PartnerAgent/PartnerAgentForm';

function WhiteLabeling() {
  const {
    form,
    values,
    loadPartnerAgentsOptions,
    isAddingNewPartner,
    handleSetAddingPartner,
    handleSubmit,
    handleCloseForm,
    handleChange,
  } = useWhiteLabeling();

  const hasWhiteLabeling = useIsSubscriptionAllowed(ACCOUNT_TYPE_AGENT, AGENT_PERMISSION_WHITE_LABELING);

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div>
          <Text type="brandon" isStrong weight="500">
            White Label
          </Text>
          <Text type="brandon" size="regular" color="gray-600">
            Use a Partner Agent’s logo on any itinerary or lookbook.
          </Text>
        </div>

        <div className={s.toggler}>
          <Toggler
            theme="SECONDARY"
            checked={values.whiteLabelingOn}
            onChange={() => form.change('whiteLabelingOn', !values.whiteLabelingOn)}
          />
          <Field component={FormGroupAdapter} name="whiteLabelingOn" type="hidden" noMargin />
        </div>
      </div>

      {values.whiteLabelingOn && (
        <>
          {isAddingNewPartner ? (
            <Modal isOpen toClose={() => handleCloseForm()}>
              <PartnerAgentForm onSubmit={handleSubmit} onCancel={handleCloseForm} />
            </Modal>
          ) : (
            <div className={s.container}>
              {!hasWhiteLabeling && (
                <div
                  className={s.whiteLabelLocker}
                  children={
                    <BlockerForAgent
                      size="11px"
                      title="White Labeling Locked!"
                      text="Please contact sales to add White Labeling to this itinerary."
                      anchor="feature-white-labeling"
                      innerStyles={{ width: '90%' }}
                      textStyles={{ lineHeight: '0.8em' }}
                      iconSize="9px"
                      buttonProps={{
                        style: {
                          fontSize: '8px',
                          minWidth: '5.8rem',
                          minHeight: '2.1rem',
                          padding: 0,
                        },
                      }}
                    />
                  }
                />
              )}
              <Field
                name="partnerAgentId"
                component={FormGroupAdapter}
                customComponent={Select}
                placeholder="Search Partner Agents"
                async
                loadOptions={loadPartnerAgentsOptions}
                onCustomChange={handleChange}
                creatable
                isClearable
                allowCreateWhileLoading
                optionToString
                noMargin
                className={s.select}
                isValidNewOption={(input) => !!input}
                tooltipContent={
                  <Text accent style={{ fontSize: '1.5rem' }}>
                    <b>Tool Tip:</b>
                    <br />
                    <br />
                    Partner Agents live on your Contacts tab and can be edited and updated from there.
                  </Text>
                }
                onCreateOption={handleSetAddingPartner}
              />

              <Field
                type="checkbox"
                component={FormGroupAdapter}
                name="whiteLabelingDisplayCompanyLogo"
                labelText="Show my logo next to the partner agent’s logo"
                disabled={isNotDefined(values.partnerAgentId)}
                className={s.logoCheckboxContainer}
                noMargin
              />
            </div>
          )}
        </>
      )}
      <Field component={'input'} name="partnerAgentId" type="hidden" />
    </div>
  );
}

export default WhiteLabeling;
